export const ssoUrl = [
  `${process.env.REACT_APP_AUTH_DOMAIN}/login?`,
  `response_type=code`,
  `&`,
  `client_id=${process.env.REACT_APP_CLIENT_ID}`,
  `&`,
  `redirect_uri=${process.env.REACT_APP_AUTH_REDIRECT}`,
].join('');

export const TOKEN_KEYS = {
  ACCESS: 'myEMS.accessToken',
  ID: 'myEMS.idToken',
  REFRESH: 'myEMS.refreshToken',
}

export const getStoredTokens = () => {
  const accessToken = localStorage.getItem(TOKEN_KEYS.ACCESS);
  const idToken = localStorage.getItem(TOKEN_KEYS.ID);
  const refreshToken = localStorage.getItem(TOKEN_KEYS.REFRESH);
  return { accessToken, idToken, refreshToken };
};

export const setStoredTokens = ({accessToken, idToken, refreshToken}) => {
  if (accessToken) {
    localStorage.setItem(TOKEN_KEYS.ACCESS, accessToken);
  }
  if (idToken) {
    localStorage.setItem(TOKEN_KEYS.ID, idToken);
  }
  if (refreshToken) {
    localStorage.setItem(TOKEN_KEYS.REFRESH, refreshToken);
  }
};

export const hasStoredTokens = () => {
  const tokens = getStoredTokens();
  return !(!tokens || !tokens.accessToken || !tokens.idToken || !tokens.refreshToken);
};

export const clearStoredTokens = () => {
  localStorage.removeItem(TOKEN_KEYS.ACCESS);
  localStorage.removeItem(TOKEN_KEYS.ID);
  localStorage.removeItem(TOKEN_KEYS.REFRESH);
};

export const isAdmin = (groups) => {
  return groups.includes('Educators');
}
